// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"311":"59ba3c7e","548":"59ba3c7e"}[chunkId] + ".chunk.css";
};